module.exports = __webpack_public_path__ + "static/media/carla_sofia.22592c3d.jpg";